import { Theme, makeStyles } from '@material-ui/core';

export const useStyles = makeStyles((theme: Theme, variant: string = 'body2') => ({
    [variant]: {
        ...theme.typography[variant],
    },
}));
